import { useRef } from "react";
import { FormattedMessage as FM } from "react-intl";

import { ChevronDownIcon } from "components/Icons";
import { cn } from "tools/ui";

function SelectionCell(props) {
  const { field, data, record, onChange } = props;
  // if (!data?.value) return null;

  let valueName, valueId;
  if (typeof data.value === "string") {
    valueName = data.value;
    valueId = data.value;
  } else if (typeof data.value === "object") {
    valueName = data.value?.name;
    valueId = data.value?.id;
  }

  // 🔹 Mantener las opciones fijas desde el primer render
  const optionsRef = useRef(null);

  if (!optionsRef.current) {
    let opts = [];
    if (Array.isArray(field?.options) && field.options.length > 0) {
      opts = field.options.map((opt) => ({
        id: opt.id ?? opt.value?.id ?? null,
        name: opt.name ?? opt.value?.name ?? null,
      }));
    } else if (Array.isArray(record?.[field.name])) {
      opts = record[field.name].map((item) => ({
        id: item.id,
        name: item.name,
        value: item?.value,
      }));
    }
    optionsRef.current = opts;
  }

  const options = optionsRef.current;

  const found = options.find((opt) => String(opt.id) === String(valueId));
  if (found) valueName = found.name;

  if (!field.editable) {
    return (
      <div
        className={cn(
          "text-sm px-2 rounded-lg w-fit min-w-4",
          field.tags?.default,
        )}
      >
        {field.translate && valueName ? <FM id={valueName} /> : valueName}
      </div>
    );
  }

  function onChangeValue(e) {
    e.stopPropagation();
    const selectedId = e.target.value;
    const _value = options.find((opt) => String(opt.id) === String(selectedId));
    if (!_value) return;
    data.value = _value;
    onChange(field, _value, record);
  }

  return (
    <div
      className={cn(
        "text-xs h-8 min-w-5 max-w-fit mx-auto flex w-full shadow-sm border border-gray-200 rounded-xl py-1 px-3 bg-white relative",
        field.tags?.default,
      )}
    >
      <select
        name={field.name}
        onChange={onChangeValue}
        className="w-full h-full outline-none pr-8 text-neutral-700 appearance-none"
        value={data.value?.id || ""}
      >
        {options.map((option, index) => (
          <option
            // key={option.id}
            key={`${option.id}-${index}`}
            value={option.id}
            className="text-center bg-neutral-100"
          >
            {option.name ?? "Sin nombre"}
          </option>
        ))}
      </select>
      <ChevronDownIcon className="absolute right-2 top-1.5 pointer-events-none z-10 w-5 fill-current" />
    </div>
  );
}

export default SelectionCell;
